import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { tap } from 'rxjs/operators';

export const loggingInterceptor: HttpInterceptorFn = (req, next) => {
    if (!environment.enableLogging) {
      return next(req);
    }

    console.log('=== HTTP REQUEST ===');
    console.log('Method:', req.method);
    console.log('URL:', req.url);
    console.log('Headers:', req.headers.keys().reduce((acc, key) => {
        acc[key] = req.headers.get(key);
        return acc;
    }, {} as any)); // eslint-disable-line
    console.log('Body:', req.body);
    console.log('==================');

    return next(req).pipe(
        tap(
            event => {
                console.log('=== HTTP RESPONSE ===');
                console.log('Event:', event);
                console.log('====================');
            },
            error => {
                console.log('=== HTTP ERROR ===');
                console.log('Error:', error);
                console.log('==================');
            }
        )
    );
};
